import $ from "jquery";

/**
 * Pin the menu bar where it currently is.
 *
 * While the panel is open the bar is `position: fixed` (the scroll lock kills the scroll
 * container that `position: sticky` hangs on, see `menu-main.scss`). A hard `top` would move
 * the bar the moment the panel opens: unscrolled it sits below the USP bar, so the Close
 * button would jump to the top of the window while Menu stood 52px lower. So measure where
 * the bar actually is and pin it there — never above the admin bar, and never off-screen
 * (below 1024 the bar is not sticky, so once the page is scrolled its own top is negative).
 *
 * Two properties come out of this:
 *   --sb-menu-open-top        where the bar is pinned
 *   --sb-menu-open-panel-top  where the panel starts — the top of the window, or the bottom of
 *                             the admin bar. The panel runs from there all the way behind the
 *                             bar, so nothing of the page (the trust indicator strip above the
 *                             bar included) shows through while the menu is open.
 */
function pinMenuBar() {
    const bar = document.querySelector(".sb_menu-main");

    if (!bar) {
        return;
    }

    const adminBar = document.getElementById("wpadminbar");
    const panelTop = adminBar
        ? Math.max(0, Math.round(adminBar.getBoundingClientRect().bottom))
        : 0;
    const top = Math.max(panelTop, Math.round(bar.getBoundingClientRect().top));
    const root = document.documentElement;

    root.style.setProperty("--sb-menu-open-top", `${top}px`);
    root.style.setProperty("--sb-menu-open-panel-top", `${panelTop}px`);
}

/**
 * Toggle menu
 */
$("body").on("click tap", "[data-toggle-menu]", () => {
    if ($("html").hasClass("s_user-clicked-menu")) {
        $("html").removeClass("s_user-clicked-menu").addClass("s_hide-menu");
    } else {
        pinMenuBar();
        $("html").addClass("s_user-clicked-menu").removeClass("s_hide-menu");
    }
});

/**
 * Open and close a menu group in the panel
 *
 * Only exists below 1024: from there the panel shows every group open, so there is no button to
 * click. The heading next to it stays a link to the overview page — the button is the only thing
 * that folds the group out, which is why the click never has to be intercepted on the heading.
 */
$("body").on(
    "click tap",
    ".sb_menu-main_overlay-menu-primary_toggle",
    function () {
        const $group = $(this).closest(
            ".sb_menu-main_overlay-menu-primary_group"
        );
        const isOpen = $group.toggleClass("s_is-open").hasClass("s_is-open");

        $(this).attr("aria-expanded", isOpen ? "true" : "false");
    }
);

/**
 * Open search overlay
 */
$("[data-open-search-overlay]").on("click tap", () => {
    openSearchOverlay();
});

/**
 * Close search overlay
 */
$("[data-close-search-overlay]").on("click tap", () => {
    closeSearchOverlay();
});

/**
 * Keyboard events
 */

$(document).on("keydown", (e) => {
    // console.log(e);
    if (e.code === "Escape") {
        $("[data-close-search-overlay]").trigger("click");
    }

    if (
        (e.metaKey || e.ctrlKey) &&
        String.fromCharCode(e.which).toLowerCase() === "k"
    ) {
        e.preventDefault();
        openSearchOverlay();
    }
});

/**
 * function - Open search overlay
 */
function openSearchOverlay() {
    $("body").addClass("s_is-open_search-overlay");
    $("#search-input").val("").trigger("focus");
}

/**
 * function - Close search overlay
 */
function closeSearchOverlay() {
    $("body").removeClass("s_is-open_search-overlay");
}

/**
 * menu-site-switcher
 */
$("#site-switcher").on("change", () => {
    const selectedPath = $("#site-switcher").val();
    if (selectedPath) {
        window.location.href = selectedPath;
    }
});
